import React from 'react';
import { node, func, oneOfType, string } from 'prop-types';

import { Tooltip } from '@/components/Tooltip';
import OverlayTrigger from '../OverlayTrigger';

const Overlay = (props) => {
  const { placement, text, children } = props;
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{text}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};

Overlay.propTypes = {
  children: oneOfType([node, func]),
  placement: string,
  text: oneOfType([node, string]),
};

Overlay.defaultProps = {
  children: null,
  placement: 'top',
  text: '',
};

export default Overlay;
